export default __webpack_public_path__ + "static/media/Mark-2-Suit-05.2ad29fbc.jpg";